import {
  BrandBgEntity,
  BrandBgEntityRaw,
  BrandCaptionLowerThirdEntity,
  BrandCaptionLowerThirdEntityRaw,
  BrandEntity,
  BrandEntityRaw,
  BrandLogoEntity,
  BrandLogoEntityRaw,
  BrandOverlayEntity,
  BrandOverlayEntityRaw
} from "@common/domain";

export function buildBrandEntity(brandEntityJson: BrandEntityRaw): BrandEntity {
  return new BrandEntity(brandEntityJson);
}

export function buildBrandLogoEntity(
  brandLogoEntityRaw: BrandLogoEntityRaw
): BrandLogoEntity {
  return new BrandLogoEntity(brandLogoEntityRaw);
}

export function buildBrandBgEntity(
  brandBgEntityRaw: BrandBgEntityRaw
): BrandBgEntity {
  return new BrandBgEntity(brandBgEntityRaw);
}

export function buildBrandOverlayEntity(
  brandOverlayEntityRaw: BrandOverlayEntityRaw
): BrandOverlayEntity {
  return new BrandOverlayEntity(brandOverlayEntityRaw);
}

export function buildBrandCaptionLowerThirdEntity(
  brandCaptionLowerThirdEntityRaw: BrandCaptionLowerThirdEntityRaw
): BrandCaptionLowerThirdEntity {
  return new BrandCaptionLowerThirdEntity(brandCaptionLowerThirdEntityRaw);
}
